module.exports = __webpack_public_path__ + "static/forecast/weather/nightrainshowers-f5f4da9ec54ef65b6209de8cb4fc7b84.svg";